import { BetterEnum } from 'shared'
import { CreateIssueFormItemsValues } from 'App/components/Routes/components/issues/hooks/useCreateIssueFormItems/components/CreateIssueFormItems/types'
import { CreateEditEJFormItemsValues } from '../../../../../EngineeringJudgements/components/EJLog/components/EJLogTable/components/CreateEditEJFormItems/types'
import { CommonEJFormItemsValues } from '../../../../../EngineeringJudgements/components/EJLog/components/EJLogTable/components/CommonEJFormItems/types'

export const Action = {
  Issue: 'Create new Issue',
  EJ: 'Create new Engineering Judgement',
  Close: 'Close without escalating',
} as const
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type Action = BetterEnum<typeof Action>

export type CreateIssueResults = {
  action: typeof Action.Issue
} & CreateIssueFormItemsValues

export type CreateEJResults = {
  action: typeof Action.EJ
} & CommonEJFormItemsValues &
  Omit<CreateEditEJFormItemsValues, 'customFields'>

export type CloseResults = {
  action: typeof Action.Close
} & { reviewNotes: string }

export type ValidatedResults =
  | CreateIssueResults
  | CreateEJResults
  | CloseResults
